import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Alert, Modal } from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'

const RemoveCourseModal = ({contextCourse, show, toggle}) => {
  const [currentState, dispatch] = useStateValue()
  const [errorText, updateErrorText] = useState(null)

  const removeCourse = async () => {
    try {
      await client.delete(endpoints.removeCourse({ contextCourseId: contextCourse.id }))
      toast.success("Successfully removed resource.")
      // Trigger the lower components useEffect hook
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
      toggle(!show)
      updateErrorText(null)
    } catch (err) {
      if (err.response.status === 500) {
        console.log('error: ', err.response)
        toast.error(`${err.response.statusText} ${err.response.data.error}`)
      } else {
        updateErrorText(err.response.data.error)
      }
    }
  }

  let errorAlert = errorText ? (
    <Alert className="alert-danger">{errorText}</Alert>
  ) : null

  return (
    <Modal show={show} onHide={() => toggle(!show)}>
      <Modal.Header closeButton>
        <Modal.Title>New Course Mapping</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorAlert}
        <p>
          Are you sure you want to remove{' '}
          <b>
            {contextCourse.title} ({contextCourse.coursenum})
          </b>
          ?
        </p>
        <div
          className="btn btn-danger btn-myed btn-danger-myed"
          onClick={() => removeCourse()}
        >
          <div className="fa-regular fa-window-close fa-fw mr-2" /> Remove
        </div>
      </Modal.Body>
    </Modal>
  )
}

RemoveCourseModal.propTypes = {
  contextCourse: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default RemoveCourseModal
